/* =====================
 *  >>> 選擇日期的工具
 *
 *  @author: Alan
 *  @time 2015 / 12 / 18
 *
 * ===================== */


window.InifECApp.directive('datepicker',  ['$timeout', function($timeout){
  return {
        restrict: 'A',
        link: function(scope, element, attr){

        	var options = undefined;
        	if(attr.datepicker){
        		options = JSON.parse(attr.datepicker);
        	}

        	if(!options) {
        		options = {};
        	}

        	options.beforeShow = function() {

    	        $timeout(function(){
    	            $('.ui-datepicker').css('z-index', 99999999999);
    	        }, 0);
    	    }

        	$(element).datepicker(options);

         //    $( "#from" ).datepicker({
	        //     dateFormat: "yy-mm-dd",
	        //     defaultDate: "+1w",
	        //     changeMonth: true,
	        //     numberOfMonths: 1,
	        //     minDate: new Date(),
	        //     onClose: function( selectedDate ) {
	        //         if(!selectedDate) {
	        //             return;
	        //         }
	        //         $( "#to" ).datepicker( "option", "minDate", selectedDate );
	        //     },
	        //     beforeShow: function (e, t) {
	        //         $(this).datepicker("hide");
	        //         $("#ui-datepicker-div").removeClass("hide-calendar");
	        //     }
	        // });
        }
    };
}]);